export { default } from './Snackbar';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Snackbar/index.js
// module id = 758
// module chunks = 121